import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from '@angular/forms';
import { Subject } from 'rxjs';
import { PasswordValidators } from 'src/app/validators/password-validators';

@Component({
  selector: 'password-complexity',
  templateUrl: './password-complexity.component.html',
  styleUrls: ['./password-complexity.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PasswordComplexityComponent,
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: PasswordComplexityComponent,
      multi: true,
    },
  ],
})
export class PasswordComplexityComponent implements ControlValueAccessor, Validator, OnInit, OnDestroy {
  @Input() placeholder: string;
  @Input() label: string;

  input = new FormControl(null, PasswordValidators.main());
  changeSubject = new Subject<string>();

  onChange: (password: string) => {};

  ngOnInit(): void {
    this.input.valueChanges.subscribe(() => {
      this.changeInputValue();
    });
  }

  ngOnDestroy(): void {
    this.changeSubject.complete();
  }

  writeValue(value: string) {
    this.setPassword(value);
  }

  changeInputValue() {
    this.changeSubject.next(this.input.value);
  }

  registerOnChange(func: (val: string) => void): void {
    this.changeSubject.subscribe(val => {
      if (func) {
        func(val);
      }
    });
  }

  registerOnTouched(onTouched: any) {
  }

  validate(): ValidationErrors | null {
    return this.input?.invalid ? { invalid: true } : null;
  }

  setPassword(value: string) {
    this.input.setValue(value);
    if (this.onChange) {
      this.onChange(value);
    }
  }

  get hasNumLettersError() {
    return !this.input?.value || this.input?.hasError('numbersAndLetters');
  }
  get hasLengthError() {
    return !this.input?.value || this.input?.hasError('minlength');
  }
  get hasUpperLowerCaseError() {
    return !this.input?.value || this.input?.hasError('upperLowerCases');
  }
}
